import React from 'react';
import { MathJaxContext, MathJax } from 'better-react-mathjax';
import DOMPurify from 'dompurify';

// bulma / bootstrap integration
const purifyConfig = {
  FORCE_BODY: true,
  ADD_TAGS: ['link', 'style'],
  // ADD_ATTR: ['href', 'rel', 'type'],
  // this is to only allow bulma / bootstrap CDN links as well as rel="stylesheet"
  ALLOWED_URI_REGEXP: /^(https:\/\/cdn\.jsdelivr\.net\/npm\/(bulma|bootstrap)[@/].*)|stylesheet$/,
};

export default function Response({ response }) {
  const mathJaxConfig = {
    loader: { load: ['input/tex', 'output/chtml'] },
    tex: {
      inlineMath: [['$', '$']],
      displayMath: [['$$', '$$']],
      processEscapes: true,
    },
  };

  return (
    <>
      {response?.type === 'text/plain' && (
        <div>
          <pre>
            <MathJaxContext config={mathJaxConfig}>
              <MathJax>
                {response.data || 'No result'}
              </MathJax>
            </MathJaxContext>
          </pre>
        </div>
      )}
      {response?.type === 'application/json' && (
        <pre>
          {JSON.stringify(response, null, 2) || 'No result'}
        </pre>
      )}
      {response?.type === 'text/html' && (
        <MathJaxContext config={mathJaxConfig}>
          <MathJax>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.data, purifyConfig) }}
            />
          </MathJax>
        </MathJaxContext>
      )}
      {response?.type.includes('image/') && (
        <img
          src={response.data}
          alt="Result"
        />
      )}
    </>
  );
}
